import { render, staticRenderFns } from "./SelectCollectionItem.vue?vue&type=template&id=735b2278&scoped=true&"
import script from "./SelectCollectionItem.vue?vue&type=script&lang=js&"
export * from "./SelectCollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectCollectionItem.vue?vue&type=style&index=0&id=735b2278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b2278",
  null
  
)

export default component.exports